import React, { ReactElement } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Select from 'components/@common/Inputs/Select';
import useDefaultGroupSettings from 'components/ClassroomsModule/hooks/use-default-group-settings';
import { useTranslation } from 'react-i18next';
import {
  FastFieldProps,
  Field,
  FormikProps,
  FormikValues,
  useField,
  useFormikContext
} from 'formik';

import useStudentsFormKey from '../../../hooks/use-students-form-key';
import { GroupCreate } from 'types/schema-generated-types';
import { StudentFieldProps } from '../../../types';

export const StudentGroupSelectField: React.FC<StudentFieldProps> = ({ index, touched }) => {
  const { t } = useTranslation();
  const { getProductCurriculumDefaultGroupSettings } = useDefaultGroupSettings();
  const { setFieldValue }: FormikProps<FormikValues> = useFormikContext();
  const studentsFormKey = useStudentsFormKey();
  const [licenses] = useField({ name: `${studentsFormKey}.${index}.licenses` });

  const assignedProductCurriculumIds: number[] =
    licenses.value?.map((x: any) => x.productCurriculumId) ?? [];

  const defaultGroups = getProductCurriculumDefaultGroupSettings(assignedProductCurriculumIds).map(
    x => x.group
  );

  const handleChange = (event: any): void => {
    setFieldValue(
      `${studentsFormKey}.${index}.group`,
      defaultGroups.find(group => group.name === event.target.value)
    );
  };

  if (defaultGroups.length === 0) return <>{'NA'}</>;

  return (
    <Field name={`${studentsFormKey}.${index}.group`}>
      {({ field, meta }: FastFieldProps): ReactElement => {
        const { value, ...remainingField } = field;
        return (
          <Select
            {...remainingField}
            placeholder={t('Group')}
            value={value?.name || ''}
            onChange={handleChange}
            error={Boolean((touched || meta.touched) && meta.error)}
            helperText={(touched || meta.touched) && meta.error}
            inputProps={{
              'aria-label': `${t('Student')} ${index + 1} ${t('Group')}`
            }}
            size="small"
          >
            {defaultGroups.map((group: GroupCreate, idx: number) => (
              <MenuItem key={idx} value={group.name}>
                {group.name}
              </MenuItem>
            ))}
          </Select>
        );
      }}
    </Field>
  );
};

export default StudentGroupSelectField;
